import React from 'react';
import { Link } from 'react-router-dom';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function PageBanner({
  imgId,
  title,
  btnText = "explore now",
  btnLink = "/collections",
  type = "small"
}) {
  return (
    <div className={`bs-banner ${type === 'small' ? 'bs-banner--typ-small' : ''}`}>
      <div className="bs-banner__media">
        <CloudinaryAdvancedImage
          imagePublicId={imgId}
          className="bs-banner__image"
          type="original"
        />
      </div>
    </div>
  );
}

export default PageBanner;
